import { SignIn } from "@clerk/react";
import { createFileRoute } from "@tanstack/react-router";
import { opsHead } from "~/head";

export const Route = createFileRoute("/sign-in")({
  head: () => opsHead("Sign In"),
  component: () => <View />,
});

const View = () => {
  return (
    <div className="flex h-full items-center justify-center bg-unauthed-shell font-text">
      <SignIn
        routing={"path"}
        path={"/sign-in"}
        fallbackRedirectUrl={"/"}
        appearance={{
          elements: {
            rootBox: "shadow-none font-title text-primary",
            cardBox: "shadow-card bg-white rounded-md",
            header: "",
            headerTitle:
              "font-title font-medium text-base text-left text-primary",
            headerSubtitle: "text-sm text-left text-tertiary",
            headerBackRow: "mb-0",
            logoBox: "h-8 flex flex-col items-start",
            logoImage: "h-8",
            socialButtonsIconButton:
              "border-transparent bg-neutral-muted grayscale rounded-sm hover:border-brand hover:grayscale-0 hover:bg-white",
            formHeader: "px-6 py-3 bg-secondary rounded-sm",
            formHeaderTitle: "text-primary",
            formHeaderSubtitle: "text-tertiary font-text",
            formButtonPrimary:
              "bg-brand text-primary-inverse rounded-sm py-3 tracking-label normal-case text-sm font-normal border-solid border border-transparent after:!shadow-none !shadow-none hover:text-white hover:bg-brand-highlight hover:border-brand-highlight",
            formFieldLabel: "font-title font-normal text-secondary",
            formFieldInput:
              "leading-6 text-primary text-base rounded-sm shadow-surface",
            formResendCodeLink: "text-primary tracking-tight",
            formFieldAction: "font-title font-normal underline text-primary",
            footerActionLink: "font-title font-normal underline text-primary",
            dividerLine: "bg-secondary-interactive-hover",
            dividerText: "text-tertiary font-normal",
            identityPreview: "rounded-full pl-2",
            identityPreviewAvatarBox: " w-8 h-8",
            identityPreviewText: "text-primary",
            identityPreviewEditButtonIcon: "w-4 text-tertiary",
            alternativeMethodsBlockButtonText: "tracking-label",
          },
        }}
      />
    </div>
  );
};
